export const appearance = {
  theme: 'stripe' as const,
  variables: {
    colorPrimary: '#0f172a',
    colorBackground: '#ffffff',
    colorText: '#0f172a',
    colorDanger: '#ef4444',
    fontFamily: 'Poppins, system-ui, -apple-system, sans-serif',
    borderRadius: '10px',
    spacingUnit: '5px',
    fontSizeBase: '14px',
    colorTextSecondary: '#64748b',
    colorBorder: '#e2e8f0',
    colorFocus: '#3b82f6',
  },
  rules: {
    '.Input': {
      border: '1px solid #e2e8f0',
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.04)',
      padding: '11px 14px',
      borderRadius: '10px',
      transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    },
    '.Input:focus': {
      borderColor: '#3b82f6',
      boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.15)',
    },
    '.Label': {
      fontWeight: '600',
      fontSize: '13px',
      color: '#334155',
      marginBottom: '6px',
    },
  },
}
